"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Money = function Money(_ref) {
  var amount = _ref.amount,
      currency = _ref.currency;
  var formattedAmount = Array.isArray(amount) ? amount[0] : amount;
  return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedNumber, {
    value: formattedAmount // eslint-disable-next-line react/style-prop-object
    ,
    style: "currency",
    currency: currency
  });
};

Money.propTypes = {
  amount: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].array]).isRequired,
  currency: _propTypes["default"].string
};
Money.defaultProps = {
  currency: 'JPY'
};

var _default = exports["default"] = Money;